export const initialState = {
    current_page: 0,
    icon_list: [],
    search_value: "",
    icons_per_page: 20,
    icon_count: 0,
}